import React from 'react';
import styles from './index.module.scss';
import Twitter from '../../assets/images/Twitter.svg';
import CustomImg from '../CustomImg';
import Facebook from '../../assets/images/Facebook.svg';
import Instagram from '../../assets/images/Instagram.svg';
import LinkedIn from '../../assets/images/LinkedIn.svg';
import Logo from '../../assets/images/Logo.svg';
import Heart from '../../assets/images/Heart.svg';
import { useIdHash } from '../../hooks/custom.hooks';
import FadeInSection from '../../wrapper/FadeInWrapper';

function Footer() {
  const { isApp } = useIdHash();
  const socialLinks = [
    { href: 'https://x.com/twidpay', src: Twitter, alt: 'Twitter' },
    {
      href: 'https://www.facebook.com/twidpay/',
      src: Facebook,
      alt: 'Facebook',
    },
    {
      href: 'https://www.linkedin.com/company/twidpay/',
      src: LinkedIn,
      alt: 'LinkedIn',
    },
    {
      href: 'https://www.instagram.com/paywithrewards/',
      src: Instagram,
      alt: 'Instagram',
    },
  ];
  return (
    <FadeInSection>
      <div className={styles.footerContainer}>
        {!isApp && (
          <div className={styles.Querycontainer}>
            <div className={styles.heading}>Ask your Queries</div>
            <div className={styles.subHeading}>Get guaranteed responses.</div>
            <a
              href="https://support.twidpay.com/support/home"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <button className={styles.button}>NEED HELP?</button>
            </a>
          </div>
        )}
        <div className={styles.socialMediaContainer}>
          {!isApp && <div className={styles.follows}>Follow us on Socials</div>}
          {!isApp && (
            <div className={styles.socialMedia}>
              {socialLinks.map(({ href, src, alt }) => (
                <a
                  key={alt}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CustomImg src={src} alt={alt} />
                </a>
              ))}
            </div>
          )}
          <div className={styles.regards}>
            <div className={styles.rewards}>Rewarding India with</div>
            <CustomImg src={Heart} alt="Heart" fallbackSrc={Heart} />
            by
            <CustomImg src={Logo} alt="Logo" fallbackSrc={Logo} />
            twid
          </div>
        </div>
      </div>
    </FadeInSection>
  );
}

export default React.memo(Footer);
